<div>
  <div class="col-md-12 no-padding">
    <legend>Quote Builder</legend>
    <div class="form-group row">
      <label class="col-sm-2 col-form-label">Commodity</label>
      <div class="col-sm-4 d-flex align-items-center">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="commodityType" id="nh3lpg" value="NH3/LPG" [(ngModel)]="commodityType">
          <label class="form-check-label" for="nh3lpg">NH3/LPG</label>
        </div>
        <div class="form-check form-check-inline" style="margin-left: 5px;">
          <input class="form-check-input" type="radio" name="commodityType" id="cryo" value="Cryo" [(ngModel)]="commodityType">
          <label class="form-check-label" for="cryo">Cryo</label>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="client" class="col-sm-2 col-form-label">Client</label>
      <div class="col-sm-4">
        <p-dropdown
          [options]="clients"
          [(ngModel)]="selectedClient"
          optionLabel="companyName"
          placeholder="Select Client"
          inputId="client"
          (onChange)="onClientSelected($event)"
        ></p-dropdown>
      </div>
    </div>
    <div class="form-group row">
      <label for="billTo" class="col-sm-2 col-form-label">Bill To</label>
      <div class="col-sm-4">
        <p-dropdown
          [options]="filteredBillTos"
          [(ngModel)]="selectedBillTo"
          optionLabel="companyName"
          placeholder="Select Bill To"
          inputId="billTo"
          [disabled]="!selectedClient"
        ></p-dropdown>
      </div>
    </div>
    <div class="form-group row">
      <label for="product" class="col-sm-2 col-form-label">Product</label>
      <div class="col-sm-4">
        <p-dropdown
          [options]="products"
          [(ngModel)]="selectedProduct"
          optionLabel="name"
          placeholder="Select Product"
          inputId="product"
        ></p-dropdown>
      </div>
    </div>
    <div class="form-group row">
      <label for="pickupLocation" class="col-sm-2 col-form-label">Pickup Location</label>
      <div class="col-sm-4">
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="pickupLocationMode"
            id="pickupLocationModeDropdown"
            value="dropdown"
            [(ngModel)]="pickupLocationInputMode"
            (change)="onPickupLocationModeChange()"
          />
          <label class="form-check-label" for="pickupLocationModeDropdown">Select Location</label>
        </div>
        <div class="form-check form-check-inline" style="margin-left: 5px;">
          <input
            class="form-check-input"
            type="radio"
            name="pickupLocationMode"
            id="pickupLocationModeManual"
            value="manual"
            [(ngModel)]="pickupLocationInputMode"
            (change)="onPickupLocationModeChange()"
          />
          <label class="form-check-label" for="pickupLocationModeManual">Enter City/State/Zip</label>
        </div>

        <div style="margin-top: 0.5rem;" *ngIf="pickupLocationInputMode === 'dropdown'">
          <app-location-picker
            [tripData]="pickupTripData"
            [isSelected]="pickupTripData?.locationId"
            [locationName]="pickupTripData?.locationName"
            (locationSelected)="onPickupLocationSelected($event)"
            tableId="quoteBuilderPickupLocationTable"
            escapeElementId="quoteBuilderPickupLocationName"
            searchFieldId="quoteBuilderPickupLocationSearch"
            [locId]="pickupTripData?.locationId"
            buttonId="openQuoteBuilderPickupLocationBtn"
            [disabled]="false"
          ></app-location-picker>
        </div>

        <div style="margin-top: 0.5rem;" *ngIf="pickupLocationInputMode === 'manual'">
          <input
            class="form-control"
            style="margin-bottom: 0.5rem;"
            placeholder="City"
            [(ngModel)]="pickupTripData.city"
          />
          <input
            class="form-control"
            style="margin-bottom: 0.5rem;"
            placeholder="State"
            [(ngModel)]="pickupTripData.state"
          />
          <input
            class="form-control"
            placeholder="Zip"
            [(ngModel)]="pickupTripData.zipcode"
          />
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="dropoffLocation" class="col-sm-2 col-form-label">Dropoff Location</label>
      <div class="col-sm-4">
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="dropoffLocationMode"
            id="dropoffLocationModeDropdown"
            value="dropdown"
            [(ngModel)]="dropoffLocationInputMode"
            (change)="onDropoffLocationModeChange()"
          />
          <label class="form-check-label" for="dropoffLocationModeDropdown">Select Location</label>
        </div>
        <div class="form-check form-check-inline" style="margin-left: 5px;">
          <input
            class="form-check-input"
            type="radio"
            name="dropoffLocationMode"
            id="dropoffLocationModeManual"
            value="manual"
            [(ngModel)]="dropoffLocationInputMode"
            (change)="onDropoffLocationModeChange()"
          />
          <label class="form-check-label" for="dropoffLocationModeManual">Enter City/State/Zip</label>
        </div>

        <div style="margin-top: 0.5rem;" *ngIf="dropoffLocationInputMode === 'dropdown'">
          <app-location-picker
            [tripData]="dropoffTripData"
            [isSelected]="dropoffTripData?.locationId"
            [locationName]="dropoffTripData?.locationName"
            (locationSelected)="onDropoffLocationSelected($event)"
            tableId="quoteBuilderDropoffLocationTable"
            escapeElementId="quoteBuilderDropoffLocationName"
            searchFieldId="quoteBuilderDropoffLocationSearch"
            [locId]="dropoffTripData?.locationId"
            buttonId="openQuoteBuilderDropoffLocationBtn"
            [disabled]="false"
          ></app-location-picker>
        </div>

        <div style="margin-top: 0.5rem;" *ngIf="dropoffLocationInputMode === 'manual'">
          <input
            class="form-control"
            style="margin-bottom: 0.5rem;"
            placeholder="City"
            [(ngModel)]="dropoffTripData.city"
          />
          <input
            class="form-control"
            style="margin-bottom: 0.5rem;"
            placeholder="State"
            [(ngModel)]="dropoffTripData.state"
          />
          <input
            class="form-control"
            placeholder="Zip"
            [(ngModel)]="dropoffTripData.zipcode"
          />
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="quoteName" class="col-sm-2 col-form-label">Quote Name</label>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control"
          id="quoteName"
          placeholder="Enter Quote Name"
          [(ngModel)]="quoteName"
        />
      </div>
    </div>
    <div class="btnRig" style="margin-top: 1rem;">
      <button class="btn btn-primary rate-btn" (click)="generateQuote()">Generate Quote</button>
      <button class="btn btn-primary rate-btn" style="margin-left: 1rem;" (click)="saveQuote()" [disabled]="!quoteResult">Save Quote</button>
      <button class="btn btn-primary rate-btn" style="margin-left: 1rem;" (click)="copyQuoteToClipboard()" [disabled]="!quoteResult">Copy Quote</button>
    </div>

    <div *ngIf="quoteResult" class="mt-4">
      <!-- Standard table for NH3/LPG -->
      <table *ngIf="commodityType !== 'Cryo'" class="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Pickup Location</th>
            <th>Delivery Location</th>
            <th>Mileage</th>
            <th>Base Rate</th>
            <th>FSC per Mile</th>
            <th>Total FSC</th>
            <th>All In Rate</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="quoteResult.pickupLocation" />
            </td>
            <td>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="quoteResult.dropoffLocation" />
            </td>
            <td>
              <input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.mileage" />
            </td>
            <td>
              <input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.baseRate" />
            </td>
            <td>
              <input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.fscPerMile" />
            </td>
            <td>
              <input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.totalFsc" />
            </td>
            <td>
              <input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.allInRate" />
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Cryo grid table -->
      <table *ngIf="commodityType === 'Cryo'" class="table table-bordered table-striped">
        <thead>
          <tr>
            <th></th>
            <th>Miles/Quantity</th>
            <th>Rate</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>Linehaul</th>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.mileage" /></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.linehaulRate" /></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.linehaulTotal" /></td>
          </tr>
          <tr>
            <th>Loading</th>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.loadingMiles" /></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.loadingRate" /></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.loadingTotal" /></td>
          </tr>
          <tr>
            <th>Unloading</th>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.unloadingMiles" /></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.unloadingRate" /></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.unloadingTotal" /></td>
          </tr>
          <tr>
            <th>Stop</th>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.stopMiles" /></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.stopRate" /></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.stopTotal" /></td>
          </tr>
          <tr>
            <th>Subtotal</th>
            <td></td>
            <td></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.subtotal" /></td>
          </tr>
          <tr>
            <th>FSC</th>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.fscMiles" /></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.fscRate" /></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.fscTotal" /></td>
          </tr>
          <tr>
            <th>Insurance Surcharge</th>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.insuranceMiles" /></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.insuranceRate" /></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.insuranceTotal" /></td>
          </tr>
          <tr>
            <th>Invoice Total</th>
            <td></td>
            <td></td>
            <td><input type="number" class="form-control form-control-sm" [(ngModel)]="quoteResult.total" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
